import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  // Tooltip,
  Table,
} from "reactstrap";

import Tooltip from "@material-ui/core/Tooltip";
import { Field, reduxForm } from "redux-form";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from "../../../Common/util";
import API from "../../../Common/api";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Alert from "reactstrap/lib/Alert";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
//import styled, { css } from "styled-components";

var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var assign_arr = [];
var unassign_arr = [];
var data_type = "";

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.getCookie = this.getCookie.bind(this);
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.toggle = this.toggle.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.getStoreList = this.getStoreList.bind(this);
    this.getSubGroupId = this.getSubGroupId.bind(this);
    this.UnAssign = this.UnAssign.bind(this);
    this.assignedOrdersList = this.assignedOrdersList.bind(this);
    this.Assign = this.Assign.bind(this);
    this.toggleOK = this.toggleOK.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.toggle2OK = this.toggle2OK.bind(this);
    this.Failedtoggle = this.Failedtoggle.bind(this);

    this.getStationList = this.getStationList.bind(this);
    this.getAudit = this.getAudit.bind(this);

    this.getReason = this.getReason.bind(this);

    this.OpenAssign = this.OpenAssign.bind(this);
    this.AssignData = this.AssignData.bind(this);

    this.state = {
      orderdata: [],
      variant_data: [],
      errReason: "",
      shelf_life_uom: [],
      ShowpopupLoader: false,
      Failedmodal: false,
      isDisableConfirm: true,
      taskid: "",
      showFilter: false,
      ShowConfirmLoader: false,
      stationType: [],
      unAssignOrder: [],
      assignOrder: [],
      isDisabledSearch: false,
      showConfirmError: false,
      auditData: [],
      reasonData: [],
      group_id: "",
      selectedOutlet: "",
      selectedDistributor: "",
      selectedLocation: "",
      selectedOrder: "",
      submitData: false,
      order: [],
      row_data: [],
      arr_data: [],
      store: [],
      subStore: [],
      distributor: [],
      selectedReason: "",
      selectedAudit: "",
      selectedPackedQty: "",
      outlet: [],
      location: [],
      EditModal: false,
      hsn_value: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      disabledcheck: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      showTable: false,
      status_type: "1",
      apply: true,
      store_id: "",
      sub_store_id: "",
      task_id: "",
      polaris_id: "",
      task_type_value: "",
      request_id: "",
      showUnAssignedOrder: false,
      showFetchDispatchData: false,
      selectedStation: "",
      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      product_id: null,
      brand_value: "",
      mc_code_value: "",

      apply1: true,
      total_value: "",
      total_quantity: "",

      shelf_life_data: [],
      modal: false,
      selectedGroup: "",
      selectedSubGroup: "",
      modal1: false,
      modal2: false,
      modalFailed: false,
      showAllItem: false,
      disabledReasonBtn: true,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      isChecked: false,
    };
  }

  Assign() {
    this.fetchDispatch();
  }

  UnAssign() {
    this.setState({
      loading_overlay: true,
    });
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post("/product/product_master/v1/orders/", { param: payload })
      .then((response) => {
    
        this.setState({
          showUnAssignedOrder: false,
          showAssignedOrder: true,
          unAssignOrder: response.data.data.unassigned_orders,
          assignOrder: response.data.data.assigned_orders,
          loading_overlay: false,
        });
      })
      .catch(function (error) {});
  }

  assignedOrdersList() {
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post("/product/product_master/v1/orders/", { param: payload })
      .then((response) => {
    
        this.setState({
          unAssignOrder: response.data.data.unassigned_orders,
          assignOrder: response.data.data.assigned_orders,
        });
      })
      .catch(function (error) {});
  }

  AssignData() {
    this.setState({
      submitData: true,
    });
    /*var arrayData = this.state.arr_data.filter(
      (item) => item.dataChecked == true
    );*/

    var arrayData = this.state.arr_data;

    var arr = [];

    for (var i = 0; i < arrayData.length; i++) {
      var obj = {};
      //arr.push(arrayData[i].id);

      obj["task_id"] = arrayData[i].id;
      obj["packed_qty"] = arrayData[i].edit_qty;
      obj["auditor"] = this.state.selectedAudit;
      obj["reason"] = arrayData[i].edit_reason;

      arr.push(obj);
    }

    const payload = {
      arr,
    };
    addAnalytics('Packing Edit', 'Confirm Packing Edit');

    API.post("/packing/v1/order/update/", { param: payload })
      .then((response) => {
        this.setState({
          success_message: response.data.message,
          failed_message: response.data.message,
          //SuccessConfirmmodal: false
        });
        if (response.data.success == true) {
          this.toggle2();
          this.setState({
            showFetchDispatchData: false,
            selectedGroup: "",
          });
        } else {
          this.Failedtoggle();
        }
        this.setState({
          SuccessConfirmmodal: false,
          showCreatedId: false,
          showSelectGroup: false,
          showNewGroup: false,
          assignLoader: false,
          assignDisabled: false,
          createDisabled: false,
          submitData: false,
        });

        //this.fetchDispatch();
      })
      .catch(function (error) {});
  }
  UnAssignData() {
    const payload = {
      location: this.state.selectedLocation,
      type: "unassign",
      group_id: this.state.selectedGroup,
      order_id: unassign_arr,
    };

    API.post("/product/product_master/v1/group/unassign/", { param: payload })
      .then((response) => {
        alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
        });

        this.fetchDispatch();
      })
      .catch(function (error) {});
  }

  checkedSingle(index, ischecked, orderid) {
    var arr = [];
    
    this.setState({
      loading_overlay: true,
    });
    let newData = this.state.arr_data;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      data_type = "assign";
      assign_arr.push(orderid);
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      data_type = "unassign";
      unassign_arr.push(orderid);
    }

  
    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),
      //binData: newData,
      arr_data: newData,
    });
  }

  toggleOK() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  toggle1() {
    this.setState((prevState) => ({ modal1: !prevState.modal1 }));
  }
  Failedtoggle() {
    this.setState((prevState) => ({ Failedmodal: !prevState.Failedmodal }));
  }

  toggle2() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
  }

  toggle2OK() {
    window.location.href = "";
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  SuccessConfirmtoggle() {
    this.setState((prevState) => ({
      SuccessConfirmmodal: !prevState.SuccessConfirmmodal,
    }));
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    sessionStorage.setItem("PUstore_id", "");
    sessionStorage.setItem("PUpolaris_id", "");
    sessionStorage.setItem("PUstatus_type", "");
    sessionStorage.setItem("PUtask_type_value", "");
    sessionStorage.setItem("PUtask_id", "");

    /* sessionStorage.setItem('store_id', this.state.store_id)
    sessionStorage.setItem('polaris_id', this.state.polaris_id)
    sessionStorage.setItem('status_type', this.state.status_type)
    sessionStorage.setItem('task_type_value', this.state.task_type_value)
    sessionStorage.setItem('task_id', this.state.task_id)
*/

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
        store_id:
          sessionStorage.getItem("store_id") == "null"
            ? ""
            : sessionStorage.getItem("store_id"),
        polaris_id:
          sessionStorage.getItem("polaris_id") == "null"
            ? ""
            : sessionStorage.getItem("polaris_id"),
        task_id:
          sessionStorage.getItem("task_id") == "null"
            ? ""
            : sessionStorage.getItem("task_id"),
        status_type:
          sessionStorage.getItem("status_type") == "null" ||
          sessionStorage.getItem("status_type") == ""
            ? "1"
            : sessionStorage.getItem("status_type"),
        task_type_value:
          sessionStorage.getItem("task_type_value") == "null"
            ? ""
            : sessionStorage.getItem("task_type_value"),
      },
      () => {
        //this.fetchDispatch();
        this.getStoreList();
        this.getStationList();
        this.getSubGroupId();
        this.getAudit();
        this.getReason();
      }
    );
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }



  getStationList() {
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post("/product/product_master/v1/sku/dropdown/", { param: payload })
      .then((response) => {
    
        this.setState({ stationType: response.data.data });
      })

      .then(async () => {});
  }

  getStoreList() {
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post("/product/product_master/v1/orderno/dropdown/", { param: payload })
      .then((response) => response.data)

      .then((data) => {
    
        this.setState({ store: data.data });
      })

      .then(async () => {});
  }

  getReason() {
    const payload = {
      location: this.state.selectedLocation,
      screen_type: "edit_ptl",
    };

    API.post("/product/product_master/v1/reason/dropdown/", { param: payload })

      .then((response) => response.data)

      .then((data) => {
      
        this.setState({ reasonData: data.data });
      })

      .then(async () => {});
  }

  getAudit() {
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post("/product/product_master/v1/auditor/dropdown/", { param: payload })

      .then((response) => response.data)

      .then((data) => {
        
        this.setState({ auditData: data.data });
      })

      .then(async () => {});
  }

  getSubGroupId() {
    const payload = {
      screen_type: "edit_ptl",
    };

    API.post("/product/product_master/v1/subgroup/", { param: payload })

      .then((response) => response.data)

      .then((data) => {

        this.setState({ subStore: data.data });
      })

      .then(async () => {});
  }

  OpenAssign(data) {
    this.setState({
      taskid: data,
    });
    this.SuccessConfirmtoggle();
  }

  handleChange1 = (e) => {
    this.setState({
      selectedGroup: e.target.value,
    });
  };

  changeSubGroup = (e) => {
    this.setState({
      selectedSubGroup: e.target.value,
    });
  };

  changeReason(evt, index, id) {
    const { arr_data } = this.state;
    
    var reason = evt.target.value;
    arr_data[index]["edit_reason"] = reason;
    arr_data[index]["isChecked"] = "false";
    $(".err_reason_" + id + "").css("display", "none");

    var arrayData = arr_data.filter((item) => item.isChecked == "true");

    var arrayData1 = arr_data.filter(
      (item) => item.status_code === 32
    );

    if(arrayData1.length === 0  ){
      this.setState({
        isDisableConfirm: true,
        errReason: "Packing is not completed for all the lines",
      });
    }else if(arrayData1.length === arr_data.length && this.state.selectedAudit !== "" && arrayData.length === 0  ){
      this.setState({
        isDisableConfirm: false,
        errReason: "",
      });
    }else{
      this.setState({
        isDisableConfirm: true,
      })

    }

   /* if (
      arrayData.length > 0 ||
      arrayData1.length > 0 ||
      this.state.selectedAudit == ""
    ) {
      this.setState({
        isDisableConfirm: true,
      });
    } else {
      this.setState({
        isDisableConfirm: false,
      });
    }*/


    this.setState({
      arr_data: arr_data,
      //tableRowsMap: this.assembleDispatchData(arr_data),
    });
  }

  changeAudit = (evt, index) => {
    const { arr_data } = this.state;
  
    var arrayData = arr_data.filter((item) => item.isChecked == "true");

    var arrayData1 = arr_data.filter(
      (item) => item.status_code === 32
    );

    this.setState({
      //isDisableConfirm: false,
      selectedAudit: evt.target.value,
    });



    if(arrayData1.length === 0  ){
      this.setState({
        isDisableConfirm: true,
        errReason: "Packing is not completed for all the lines",
      });
    }else if(arrayData1.length === arr_data.length && evt.target.value !== "" && arrayData.length === 0  ){
      console.log("test");
      this.setState({
        isDisableConfirm: false,
        errReason: "",
      });
    }else{
      this.setState({
        isDisableConfirm: true,
      })

    }

    if(arrayData.length > 0){
      this.setState({
        isDisableConfirm: true
      })
    }

    if(evt.target.value == ""){
      this.setState({
        isDisableConfirm: true
      })
    }

    //#comment
    /*if (arrayData1.length > 0) {
      this.setState({
        errReason: "Packing is not completed for all the lines",
      });
    } else {
      this.setState({
        errReason: "",
      });
    }
    if (
      arrayData.length > 0 ||
      arrayData1.length > 0 ||
      evt.target.value == ""
    ) {
      this.setState({
        isDisableConfirm: true,
      });
    } else {
      this.setState({
        isDisableConfirm: false,
      });
    }*/


    /* const {arr_data} = this.state;
    var auditor = evt.target.value
    arr_data[index]['edit_auditor'] = auditor

  
    this.setState({
      arr_data: arr_data,
      tableRowsMap: this.assembleDispatchData(arr_data),
    });*/
  };

  changePackedQty = (evt, index, id, order_qty) => {
    this.setState({
      isDisableConfirm: true
    })
    
    const { arr_data } = this.state;
    const value = evt.target.value.replace(/\D/g, "");

    var packed_qty = value;

    var objIndex = arr_data.findIndex((obj) => obj.id == id);
    arr_data[objIndex]["edit_qty"] = packed_qty;
    arr_data[objIndex]["total_dispatch_qty"] = packed_qty;
    if (
      evt.target.value == "" ||
      evt.target.value == undefined ||
      evt.target.value == null
    ) {
      arr_data[objIndex]["isChecked"] = "false";
      arr_data[objIndex]["dataChecked"] = false;
    } else {
      arr_data[objIndex]["isChecked"] = "true";
      arr_data[objIndex]["dataChecked"] = true;
      if (packed_qty > order_qty) {
        arr_data[objIndex]["packedFlag"] = true;
      } else {
        arr_data[objIndex]["packedFlag"] = false;
      }
    }


    this.setState({
      arr_data: arr_data,
      tableRowsMap: this.assembleDispatchData(arr_data),
    });
  };

  handleChangeStation = (e) => {
    this.setState({
      selectedStation: e.target.value,
    });
  };

  assembleDispatchData = (dispatchData) => {
    let DispatchData = dispatchData.map((post, index) => {
      let text = "Alternative Product : " + "SKU7CODE - "  + post.alt_product_sku7 + " , " + "MRP - " + post.alt_product_mrp;
      return {
        icon: post.alt_product_mrp || post.alt_product_sku7? (
          <span>
            {" "}
            <Tooltip title={text} placement="right">
              <span style={{ color: "red" }} href="#">
                <i class="fa fa-info-circle"></i>
              </span>
            </Tooltip>
          </span>
        ) : (
          <span style={{ width: 40 }}></span>
        ),
        product: post.product,
        order_no :post.order_no,
        product_desc: post.product_desc,
        mrp: post.mrp,
        upc: post.upc,
        order_qty: post.order_qty,
        total_packed_qty: post.total_packed_qty,
        packed_qty: (
          <span>
            <input
              value={post.edit_qty}
              disabled={post.child_product == true ? true : false}
              style={{ fontSize: 12, height: 31, width: 120 }}
              type="text"
              className="form-control"
              placeholder="Enter Packed Qty"
              onChange={(evt) =>
                this.changePackedQty(evt, index, post.id, post.order_qty)
              }
            />{" "}
            <br />
            {post.packedFlag == true && (
              <span
                className={"err_qty_" + post.id}
                style={{ fontSize: 12, color: "red" }}
              >
                Qty Cannot be greater than To pack qty
              </span>
            )}
          </span>
        ),
        total_dispatch_qty: post.total_dispatch_qty,

        edit_reason: (
          <span>
            {" "}
            <select
              className="form-control"
              disabled={post.child_product == true ? true : false}
              defaultValue={post.reason}
              style={{ fontSize: 13, width: 120 }}
              onChange={(evt) => this.changeReason(evt, index, post.id)}
            >
              <option value="">Select Reason</option>
              {this.state.reasonData.length > 0 &&
                this.state.reasonData.map((reasonData) => {
                  return (
                    <option value={reasonData.id}> {reasonData.name}</option>
                  );
                })}
            </select>{" "}
            <br />{" "}
            {post.isChecked == "true" && (
              <span
                className={"err_reason_" + post.id}
                style={{ fontSize: 12, color: "red" }}
              >
                {" "}
                Please Select Reason
              </span>
            )}
          </span>
        ),

        /*action: <a style={{color: '#70bbfd'}}  onClick={(e) => this.AssignData(post.id, post.edit_qty, post.edit_auditor, post.edit_reason)} > Save </a>,  */
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };

  SearchData() {
    
    this.setState({
      loading_overlay: true,
    });
    var newArrData = [];
    newArrData = this.state.arr_data.filter(
      (item) =>
        item.party_code == this.state.selectedOutlet ||
        item.distributor_code == this.state.selectedDistributor ||
        item.delivery_center == this.state.selectedLocation ||
        item.outlet_order_no == this.state.selectedOrder
    );

    this.setState({
      arr_data: newArrData,
      tableRowsMap: this.assembleDispatchData(newArrData),
    });
  }

  downloadError = () => {
    //this.setState({loading:true})
    const payload = {
      location: this.state.selectedLocation,
      group_id: this.state.selectedGroup,
      station_type: this.state.selectedStation,
    };

    API.post("/product/product_master/v1/task/fetch/", { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          //showFetchDispatchData: true,
          loading: false,
        });

        window.location.href = data.data[0];
      })
      .catch(function (error) {});
  };

  checkAll() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: true,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

      /*
      this.setState({
        isdisableAssignBtn: false,
      });*/
    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

      /*
      this.setState({
        isdisableAssignBtn: true,
      });*/
    }
  }

  fetchDispatch = (order_no) => {
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem("batch_id");

    const payload = {
      //location: this.state.selectedLocation,
      bill_no: this.state.selectedGroup,
      sku: this.state.selectedStation,
      sub_group_id: this.state.selectedSubGroup,
      //request_type: "view"
    };
    addAnalytics('Packing Edit', 'Packing Edit Search Filter', payload);

    API.post("/packing/v1/order/view/", { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          showFetchDispatchData: true,
          loading: false,
        });

        if (data.data.length == 0) {
          this.toggle();
          // alert(data.message)
          this.setState({
            dispatch_status: true,
            showFetchDispatchData: false,
            loading_overlay: false,
            loading: false,
          });
          return false;
        }

        let AssignData = data.data.map((item) => ({
          ...item,
          isChecked: false,
        }));

        if (AssignData[0].status == 0) {
          this.setState({
            disabledcheck: false,
          });
        } else {
          this.setState({
            disabledcheck: true,
          });
        }

        let DataValue = data.data.map((item) => ({
          ...item,
          edit_reason: "",
          edit_auditor: "",
          edit_qty: item.total_packed_qty,
          isChecked: "",
          dataChecked: false,
          packedFlag: false,
        }));

        var arrayData1 = data.data.filter(
          (item) => item.status_code === 32
        );

        if (arrayData1.length === data.data.length) {
          this.setState({
            errReason: "",
            isDisableConfirm: true,
            selectedAudit: ""
          });
         
        } else {

           this.setState({
            errReason: "Packing is not completed for all the lines",
            isDisableConfirm: true,
            selectedAudit: ""
          });
          
        }

        this.setState({
          orderData: data.data,
          total_value: data.data.total_value,
          total_quantity: data.data.total_qty,
          arr_data: DataValue,
          tableRowsMap: this.assembleDispatchData(DataValue),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function (error) {});
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2 } = this.state;
    const { SuccessConfirmmodal, Failedmodal } = this.state;

    const dispatchData = {
      columns: [
        
        {
          label: "Order No.",

          field: "order_no",
          width: 180,
        },


        {
          label: "Product",

          field: "product",
          width: 180,
        },

        {
          label: "Product Desc",

          field: "product_desc",
          width: 200,
        },

        {
          label: "MRP",

          field: "mrp",
          width: 150,
        },
        {
          label: "UPC",

          field: "upc",
          width: 150,
        },
        {
          label: "To Pack",

          field: "order_qty",
          width: 150,
        },
        {
          label: "Packed qty",

          field: "total_packed_qty",
          width: 150,
        },
        {
          label: "Confirm Packed qty",

          field: "packed_qty",
          width: 150,
        },
        {
          label: "To be Dispatch Qty",

          field: "total_dispatch_qty",
          width: 150,
        },

        {
          label: "Select Reason",

          field: "edit_reason",
          width: 200,
        },
      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <CardBody style={{ paddingTop: 10, height: 56, paddingBottom: 0 }}>
            <form className="form form--inline" onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-3"
                style={{ marginBottom: "0px" }}
              >
                <div className="form__form-group-field">
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.changeSubGroup}
                  >
                    <option value="">Select Sub Group</option>
                    {this.state.subStore.length > 0 &&
                      this.state.subStore.map((subStore) => {
                        return (
                          <option value={subStore.id}> {subStore.name}</option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px" }}
              >
                <div className="form__form-group-field">
                  <input
                    style={{ fontSize: 12, borderColor: "#ced4da" }}
                    type="text"
                    className="form-control"
                    placeholder="Enter Bill No."
                    onChange={this.handleChange1}
                  />
                  {/*<select
                    className="form-control"
                    value={this.state.selectedGroup}
                    style={{ fontSize: 13 }}
                    onChange={this.handleChange1}
                  >
                    <option value="">Select Bill No.</option>
                    {
                      this.state.store.length > 0 &&
                      this.state.store.map((store) => {
                        return (
                          <option value={store}> {store}</option>
                        );
                      })}
                  </select>*/}
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-flex", marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                  <input
                    style={{ fontSize: 12, borderColor: "#ced4da" }}
                    type="text"
                    className="form-control"
                    placeholder="Enter SKU"
                    onChange={this.handleChangeStation}
                  />
                  {/*<select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.handleChangeStation}
                  >
                    <option value="">Select SKU</option>
                    {
                      this.state.stationType.length > 0 &&
                      this.state.stationType.map((stationType) => {
                        return (
                          <option value={stationType}> {stationType}</option>
                        );
                      })}
                  </select>*/}
                </div>
              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchDispatch()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Search
                  </Button>
                </ButtonToolbar>
              </div>
            </form>
          </CardBody>

          {this.state.showFetchDispatchData && (
            <CardBody style={{ marginTop: 2, paddingTop: 0, paddingBottom: 0 }}>
              <div
                className="dispatchData stock_check_data style_table"
                style={{ marginTop: -27 }}
              >
                <select
                  className="form-control"
                  value={this.state.selectedAudit}
                  onChange={this.changeAudit}
                  style={{
                    marginBottom: 0,
                    marginTop: 34,
                    paddingTop: 5,
                    paddingBottom: 5,
                    paddingLeft: 26,
                    paddingRight: 26,
                    fontSize: 13,
                    width: 200,
                    float: "left",
                    marginRight: 6,
                  }}
                >
                  <option value="">Select Auditor</option>
                  {this.state.auditData.length > 0 &&
                    this.state.auditData.map((auditData) => {
                      return <option value={auditData}> {auditData}</option>;
                    })}
                </select>

                <Button
                  disabled={this.state.isDisableConfirm}
                  style={{
                    marginBottom: 0,
                    marginTop: 34,
                    paddingTop: 5,
                    paddingBottom: 5,
                    paddingLeft: 26,
                    paddingRight: 26,
                    fontWeight: "bold",
                  }}
                  variant="warning"
                  onClick={(e) => this.SuccessConfirmtoggle()}
                >
                  Confirm
                </Button>
                <div style={{ width: "100%", float: "left", marginTop: 15 }}>
                  <span
                    style={{ color: "red", fontSize: 12, fontWeight: "bold" }}
                  >
                    {this.state.errReason}
                  </span>
                </div>
                <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="390px"
                  displayEntries={false}
                  paging={false}
                  sorting={false}
                  striped
                  bordered
                  data={dispatchData}
                />
              </div>
            </CardBody>
          )}
        </Card>

        <Modal isOpen={modal} backdrop="static" toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-down modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>No Records Available </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
        <Modal isOpen={modal2} backdrop="static" toggle={this.toggle2}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle2}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6", margin: 4 }}
            />
            <h4>Successfully Updated</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggle2OK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          backdrop="static"
          isOpen={Failedmodal}
          toggle={this.Failedtoggle}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          backdrop="static"
          isOpen={SuccessConfirmmodal}
          toggle={this.SuccessConfirmtoggle}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessConfirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <h4>
              Please Check Picked Quantity and Press Ok Button for further
              process{" "}
            </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{  marginRight: 8 }}
              className="modal_cancel"
              onClick={this.SuccessConfirmtoggle}
            >
              Cancel
            </button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.AssignData}
            >
              {this.state.submitData && (
                <i
                  className="fa fa-refresh fa-spin"
                  style={{ marginRight: "5px" }}
                />
              )}
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
